export default "__VITE_ASSET__DnDPon9C__"